// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34gch","content":"styles_content__2fP8n","tableWrap":"styles_tableWrap__2B12q"};